<!-- User Info/Edit Modal -->
<div
  style="overflow-y: auto"
  mdbModal
  #fiaDocumentsModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  (close)="onClosed($event)"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ userProfile.fullName }} - FIA Supporting Documentation</h4>
      </div>
      <div class="modal-body" *ngIf="!showDeleteConfirmation">
        <p class="text-left">
          This is where you can manage the shared supporting documents that are automatically included with each new FIA application
        </p>
        <hr />
        <!--Error Display-->
        <div *ngIf="!busy">
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <!--Main Body-->
          <div class="selection-item-full">
            <div class="dropzone" filedropzone="">
              <div class="text-wrapper">
                <i class="fas fa-upload"></i>
                <p class="hidden-sm-down">
                  <a class="is-link"><strong>Browse</strong></a> to select files from your computer
                </p>
                <p class="hidden-sm-up">Click/tap to add your files or drag and drop them here</p>
              </div>
              <input
                class="hidden w-100 h-100"
                type="file"
                multiple="multiple"
                #file
                (change)="onFileChange($event)"
                name="fileUploadArea"
              />
            </div>
          </div>

          <div class="d-block col-12 text-center" *ngIf="userDocuments?.length > 0">
            <p class="font-weight-bold mb-1">Existing Documents</p>
          </div>
          <div class="col-12">
            <div class="table-responsive">
              <table
                mdbTable
                class="table table-responsive w-100 d-block d-md-table"
                hover="true"
                small="true"
                responsive="true"
                *ngIf="userDocuments?.length > 0"
              >
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Date Created</th>
                    <th scope="col">Type</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr mdbTableCol *ngFor="let doc of userDocuments">
                    <th scope="row" class="align-middle">{{ doc.name }}</th>
                    <td class="align-middle">{{ doc.createdDate | date }}</td>
                    <td class="align-middle">{{ doc.fileType }}</td>
                    <td>
                      <a class="border dropdown-item text-center my-1" size="sm" (click)="DownloadFile(doc.id)" mdbWavesEffect>Download</a>
                    </td>
                    <td>
                      <a class="border dropdown-item text-center my-1" size="sm" (click)="confirmDelete(doc)" mdbWavesEffect>Delete</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12">
            <div
              *ngIf="!busy && userDocuments?.length == 0 && userNewDocuments?.length == 0"
              class="alert alert-info text-center font-weight-bold"
              role="alert"
            >
              No supporting documents uploaded
            </div>
          </div>
          <div class="col-12 mt-3" *ngIf="!busy && userNewDocuments?.length > 0">
            <div class="d-block col-12 text-center">
              <p class="font-weight-bold mb-1">New Documents</p>
            </div>
            <table class="col-12" mdbTable *ngIf="userNewDocuments?.length > 0" hover="true" small="true" responsive="true">
              <thead>
                <tr>
                  <th scope="col" class="col-4">File Name</th>
                  <th scope="col" class="col-6">Type *</th>
                  <th scope="col" class="col-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr mdbTableCol *ngFor="let docs of userNewDocuments">
                  <td class="align-middle">{{ docs.fileName }}</td>
                  <td class="align-middle">
                    <select
                      class="form-control"
                      [(ngModel)]="docs.fileType"
                      required
                      placeholder="Select document type"
                      style="display: block !important"
                    >
                      <option [ngValue]="''" disabled>Select type</option>
                      <option ngValue="Statement of Assets And Liabilities">Statement of Assets And Liabilities</option>
                      <option ngValue="Loan Agreement">Loan</option>
                      <option ngValue="Proof Of Source">Savings/Cash</option>
                      <option ngValue="Other">Other</option>
                    </select>
                  </td>
                  <td class="align-middle">
                    <a class="border dropdown-item text-center my-1" size="sm" (click)="removeFile(docs.fileName)" mdbWavesEffect>Remove</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--Loading-->
        <div class="col-12 text-center">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <!--Save btn-->
        <div class="modal-footer justify-content-right">
          <button
            *ngIf="!busy && userNewDocuments?.length > 0"
            type="button"
            mdbBtn
            color="trakly-action"
            class="relative waves-light"
            (click)="newSupportingDocumentsModalSaveClicked()"
            [disabled]="missingDocumentTypes()"
          >
            Save
          </button>
          <button *ngIf="!busy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">
            Close
          </button>
        </div>
      </div>
      <div class="modal-body" *ngIf="showDeleteConfirmation">
        <!--Header-->
        <div class="alert alert-info d-flex justify-content-center">
          <p class="heading text-center">
            <b>Are you sure you would like to delete this document?</b> <br />
            {{ documentToDeleteName }}
          </p>
        </div>
        <!--Body-->
        <div class="modal-body text-center">
          <mdb-icon fas icon="times" size="4x" class="animated rotateIn"></mdb-icon>
        </div>
        <!--Footer-->
        <div class="modal-footer justify-content-center">
          <a mdbBtn color="danger" outline="true" class="waves-effect" (click)="confirmDeleteModalYesClicked()" mdbWavesEffect>Yes</a>
          <a type="button" mdbBtn color="danger" class="waves-effect" mdbWavesEffect data-dismiss="modal" (click)="cancelDelete()">No</a>
        </div>
      </div>
    </div>
  </div>
</div>
